import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import {
  CONFIG_KEYS_UPDATED_EVENT,
  getConfigKeyContent,
  invalidateConfigKeysCache,
} from '@/services/config/config-keys-store';

export const ACTION_PLAN_V2_CONFIG_KEY = 'config_setting_action_plan_v2';

/** Switch Thiết lập › Cấu hình: Sử dụng Action Plan V2 (mặc định tắt = Action Plan bản cũ). */
export function useActionPlanV2Enabled() {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = () => {
      void getConfigKeyContent(ACTION_PLAN_V2_CONFIG_KEY, 'false')
        .then((value) => {
          if (!cancelled) setEnabled(value === 'true');
        })
        .catch(() => {
          if (!cancelled) setEnabled(false);
        });
    };

    load();

    window.addEventListener(CONFIG_KEYS_UPDATED_EVENT, load);
    window.addEventListener('bsc-config-updated', load);

    return () => {
      cancelled = true;
      window.removeEventListener(CONFIG_KEYS_UPDATED_EVENT, load);
      window.removeEventListener('bsc-config-updated', load);
    };
  }, []);

  return {
    enabled: enabled ?? false,
    /** Đã đọc xong setting — chỉ chuyển hướng trang sau khi loaded */
    loaded: enabled !== null,
  };
}

/**
 * Trang chỉ thuộc một bản Action Plan: sai bản đang bật thì chuyển sang bản đúng
 * (V2 tắt → `/du-an`; V2 bật → `/action-plan-v2`). Trả `true` khi đã đọc setting và đúng bản.
 */
export function useActionPlanVersionGuard(version: 'v1' | 'v2'): boolean {
  const router = useRouter();
  const { enabled, loaded } = useActionPlanV2Enabled();
  const allowed = loaded && enabled === (version === 'v2');

  useEffect(() => {
    if (!loaded || allowed) return;
    void router.replace(version === 'v2' ? '/du-an' : '/action-plan-v2?view=employee');
  }, [loaded, allowed, version, router]);

  return allowed;
}

export function invalidateActionPlanV2ConfigCache() {
  invalidateConfigKeysCache();
}
